module.exports = __webpack_public_path__ + "img/advice-1.d3b5ab39.png";